import createReducer from './utils/createReducer';
import * as c from '../constants/actions';

const initialState = {
  countries: [],
  isLoading: false,
  error: null,
};

export default createReducer(initialState, {
  [c.GET_COUNTRIES_LIST_REQUEST]: state => ({
    ...state,
    error: null,
    isLoading: true,
  }),
  [c.GET_COUNTRIES_LIST_SUCCESS]: (state, { payload }) => ({
    ...state,
    countries: payload,
    error: null,
    isLoading: false,
  }),
  [c.GET_COUNTRIES_LIST_ERROR]: (state, { payload }) => ({
    ...state,
    error: payload,
    isLoading: false,
  }),
});
